import { createSelector } from "reselect";
import { OrderStatus } from "./common";

export const orderVerification = state => state.orderVerification;

export const status = state => orderVerification(state).status;

export const isComplete = state => status(state) === OrderStatus.complete;
export const isExpired = state => status(state) === OrderStatus.expired;
export const isPending = state => status(state) === OrderStatus.pending;

export const isModalOpen = state =>
  orderVerification(state).isModalOpen || false;

export const currentFlowStage = state => {
  const { flow, flowCursor } = orderVerification(state);

  return flow[flowCursor] != null ? flow[flowCursor] : "";
};

const selectedPhoneNumberId = state =>
  orderVerification(state).selectedPhoneNumberId;

export const selectedPhone = createSelector(
  orderVerification,
  selectedPhoneNumberId,
  ({ phoneNumbers }, phoneNumberId) => {
    for (const phoneNumber of phoneNumbers)
      if (phoneNumber.id === phoneNumberId) return phoneNumber;

    return null;
  }
);

const phoneNumbers = ({ phoneNumbers }) => phoneNumbers;

export const getPhoneNumbers = createSelector(
  phoneNumbers,
  phoneNumbersParam => {
    return (
      phoneNumbersParam.map(item => ({
        ...item,
        value: item.id,
        label: item.maskedPhone
      })) || []
    );
  }
);
